import AjaxLoad from '../../utilities/js/ajax-loader';

class DownloadsData {
    constructor (element, options) {
        this.$downloadData = element;
        const settings = {
            content: document.querySelector('[data-download="content"]')
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        const selects = this.$downloadData.getElementsByTagName('select');

        for (let i = 0; i < selects.length; i++) {
            selects[i].addEventListener('change', () => {
                this.submitForm();
            });
        }
    }

    // submit filter form and replace content from response
    submitForm () {
        const $loader = document.createElement('span');
        $loader.innerHTML = window.OPTIONS.loader;
        this.$downloadData.appendChild($loader);

        const $downloadContainer = document.querySelector('[data-download-data="container"]');
        const $form = this.$downloadData;
        const formData = new FormData($form);

        new AjaxLoad($form.action, { // eslint-disable-line
            requestMethod: $form.method,
            requestData: formData,
            onSuccess: (resultText) => {
                const $result = document.createElement('div');
                $result.innerHTML = resultText;
                this.settings.content.innerHTML = '';

                if ($result) {
                    this.settings.content.appendChild($result);
                }

                const contentUpdateEvent = new CustomEvent('content.loaded', {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    detail: {
                        $context: $downloadContainer
                    }
                });

                window.dispatchEvent(contentUpdateEvent);
            }
        });
    }
}

export { DownloadsData };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-download-select="form"]');
        $$roots.forEach($root => {
            const $rootAPI = new DownloadsData($root);
            $rootAPI.initialize();
        });
    }
});
